import {  Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { CurrentMdInfo } from 'app/models';
import { SecurityService, StateService } from 'app/services';
import { Subscription } from 'rxjs';

@Component({
    selector: 'top-menu',
    templateUrl: './top-menu.html',
    styleUrls: ['./top-menu.scss'],
})
export class TopMenu implements OnInit, OnDestroy  {
    private routerSubscription: Subscription;

    version = "0.20.4";

    userName: String;
    isLoggedIn: boolean = false;
    currentMatchDay: CurrentMdInfo;
    isNationalManager: boolean = false;
    
    constructor(private router: Router, private securityService: SecurityService,
        private stateService: StateService) { }

    ngOnInit() {
        this.refreshUserStatus();
        this.refreshMatchDayInfo();
        this.routerSubscription = this.router.events.subscribe((val) => {
            if(val instanceof NavigationStart) {
                this.refreshUserStatus();
                this.refreshMatchDayInfo();
            }
        });
    }

    ngOnDestroy(){
        this.routerSubscription.unsubscribe();
    }



    refreshUserStatus(){
        this.securityService.getCachedAuths()
            .subscribe(result => {
                let response = result;
                this.isLoggedIn = response.userName ? true:  false;
                this.isNationalManager = result.nationalTeamId ?  true: false;
                this.userName = response.userName;
            });
    }

    refreshMatchDayInfo(){
        this.stateService.getCurrentMatchDay()
            .subscribe(result => {
                this.currentMatchDay = result;
            });
    }

    gotoRoster() {
        this.router.navigate(['roster']);
    }

    gotoTactic() {
        this.router.navigate(['tactic']);
    }

    gotoNationalTactic() {
        this.router.navigate(['national/tactic']);
    }
}